import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_session-booking-23/artifacts/m475f9vu_IMG_24882.JPG";

const scrollToPathway = (e) => {
  e.preventDefault();
  document.getElementById("pathway")?.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => (
  <section
    className="relative bg-[#F6F1EA] overflow-hidden pt-28 pb-14 sm:pt-32 sm:pb-16"
    data-testid="hero-section"
  >
    <div className="max-w-[1300px] mx-auto px-6 sm:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
      <div className="lg:col-span-7 lg:pr-4 order-2 lg:order-1">
        <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-5" data-testid="hero-eyebrow">
          Faith &amp; Identity Coaching
        </p>
        <h1
          className="font-serif text-4xl sm:text-5xl lg:text-[54px] text-[#4F5D4F] leading-[1.08] tracking-tight"
          data-testid="hero-headline"
        >
          Your questions are <em className="italic text-[#B89B63]">safe here.</em>
          <br />
          You do not have to feel alone.
        </h1>
        <p
          className="mt-6 font-serif text-xl sm:text-2xl text-[#4F5D4F] leading-snug tracking-tight max-w-xl font-light"
          data-testid="hero-subhead"
        >
          You're not lost. You're not broken. You're becoming whole again.
        </p>

        <div className="mt-6 text-base sm:text-lg text-[#4F5D4F]/85 leading-relaxed max-w-xl font-light space-y-3">
          <p>
            When you start to question what you've believed, it can feel like your entire
            identity changes with it. It can make you question everything.
          </p>
          <p className="font-serif italic text-lg text-[#4F5D4F]/75" data-testid="hero-questions">
            Who am I? What do I believe? Can I trust myself? What do I actually want?
            What if I get it wrong? What if God is still there? Who is God really?
          </p>
          <p>You don't have to answer all of those questions today. You just need somewhere safe to ask them.</p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-4 sm:gap-5">
          <Link
            to="/pause-the-spiral"
            className="group inline-flex items-center gap-3 bg-[#4F5D4F] text-[#F6F1EA] hover:bg-[#3a453a] px-7 py-4 text-xs tracking-eyebrow uppercase transition-colors"
            data-testid="hero-cta-primary"
          >
            Begin with a Quiet Pause
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="#pathway"
            onClick={scrollToPathway}
            className="text-xs tracking-eyebrow uppercase text-[#4F5D4F] border-b border-[#4F5D4F] hover:border-[#B89B63] hover:text-[#B89B63] pb-1 transition-colors"
            data-testid="hero-cta-secondary"
          >
            See how we can work together
          </a>
        </div>
      </div>

      <div className="lg:col-span-5 order-1 lg:order-2 relative">
        <div className="relative aspect-[4/5] w-full max-w-[380px] mx-auto lg:ml-auto">
          <div className="absolute -top-5 -left-5 w-24 h-24 bg-[#D7B2A3]/60 z-0" />
          <div className="absolute -bottom-6 -right-5 w-32 h-32 border border-[#B89B63] z-0" />
          <img
            src={HERO_IMG}
            alt="A quiet moment of stillness — an invitation to pause and hear yourself"
            className="relative z-10 w-full h-full object-cover"
            data-testid="hero-image"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
